import React from 'react';
import styled from 'styled-components';

interface LabelProps {
  text: string;
  info?: boolean;
  conditional?: boolean;
}

export const Label: React.FC<LabelProps> = ({ text }) => (
  <>
    <LabelHolder>
      <LabelText>{text}</LabelText>
    </LabelHolder>
  </>
);

export const Placeholder = styled.div`
  line-height: 100%;
  text-align: left;
  font-size: 15px;
  font-weight: 400;
  margin-left: 18px;
  color: ${(props) => props.theme.palette.text.secondary};
  padding-top: 5px;
`;

export const StandardInputFrame = styled.div`
  position: relative;
  padding-top: 14px;
  padding-bottom: 14px;
  min-height: 50px;
  box-shadow: 0px 1px 4px 0px ${(props) => props.theme.palette.action.disabledBackground};
`;
export const LabelText = styled.div`
  font-weight: 500;
  font-size: 15px;
  text-align: left;
  margin-left: 18px;
  color: ${(props) => props.theme.palette.text.primary};
`;
export const LabelHolder = styled.div`
  display: flex;
`;
